import _defineProperty from "@babel/runtime/helpers/defineProperty";
/* eslint-disable camelcase */

import { CallbackTypes, UserAddressCommandNames } from '@chegg/commerce-utils';
import { doFireLogEvent } from '../../../utils/CallbackUtils';
import { sendNewRelicMessage } from '../../../utils/NewRelicUtils';
import { handleVerifyAddress } from './handleVerifyAddress';
import { handleAddressUpdate } from './handleAddressUpdate';
import { handleUAProgressUpdate } from './handleUAProgressUpdate';
var USER_ADDRESS_COMMAND_MAP = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, UserAddressCommandNames.UA_PROGRESS_STATUS, handleUAProgressUpdate), UserAddressCommandNames.VERIFY_ADDRESS, handleVerifyAddress), UserAddressCommandNames.ADDRESS_UPDATE, handleAddressUpdate), UserAddressCommandNames.SAVE_CONFIGS, function () {});

/**
 * Util to handle callbacks and command from User Address
 * @param callbackPayload
 * @param dispatchAddressUpdate
 * @param dispatch
 * @param ui
 * @param paymentForm
 * @param paymentErrorModal
 */
export var callback = function callback(params) {
  var callbackPayload = params.callbackPayload,
    dispatchAddressUpdate = params.dispatchAddressUpdate,
    ui = params.ui,
    dispatch = params.dispatch,
    paymentForm = params.paymentForm,
    paymentErrorModal = params.paymentErrorModal;
  var callbackType = callbackPayload.callbackType,
    data = callbackPayload.data;
  switch (callbackType) {
    case CallbackTypes.LOG_EVENT:
      doFireLogEvent(data);
      break;
    case CallbackTypes.STATUS_UPDATE:
      var statusUpdates = data;
      statusUpdates.forEach(function (statusUpdate) {
        var command = statusUpdate.command;
        if (command && Object.keys(USER_ADDRESS_COMMAND_MAP).includes(command)) {
          USER_ADDRESS_COMMAND_MAP[command]({
            statusUpdate: statusUpdate,
            dispatchAddressUpdate: dispatchAddressUpdate,
            dispatch: dispatch,
            ui: ui,
            paymentForm: paymentForm,
            paymentErrorModal: paymentErrorModal
          });
        }
      });
      break;
    default:
      sendNewRelicMessage('UserAddress callback: unsupported CallbackType', {
        errors: JSON.stringify({
          callbackType: callbackType
        })
      });
      break;
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/UserAddress/utils/UserAddressCallback.js
// module id = 4553
// module chunks = 11